import { render, staticRenderFns } from "./contrast.vue?vue&type=template&id=ca50247a&"
import script from "./contrast.vue?vue&type=script&lang=js&"
export * from "./contrast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports